import { ToastItem, toast } from "react-toastify";
import { IS_DEMO } from "../../config/constants";
import { translate } from "../../intl";

export const buildToastSuccess = (data?: any, message?: string) => {
  if (data) {
    toast.success(message ?? translate("feedback.formSentSuccessfully"), {
      closeButton: true,
      draggable: false,
    });

    if (!IS_DEMO) {
      toast.onChange((toast: ToastItem) => {
        if (toast.status === "removed") {
          window.location.reload();
        }
      });
    }
  }
};
